/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createAsyncThunk } from '@reduxjs/toolkit';

import { CreateAsyncThunk } from '../../../../ts/state';
import { Template, AllTemplateMetadata } from '../../../../ts/templates';
import * as API from '../../api/templates';
import { addErrorMessage } from '../messages/actions';

export const getTemplate = createAsyncThunk<Template, string, CreateAsyncThunk>(
  'templates/getTemplate',
  async (templateId, { dispatch }) => {
    try {
      /**
       * NOTE: In the future, when we have template JSON's in other
       * languages (e.g. French, Spanish), we'll want to pull the skill language
       * to build the templateFileName and pass templateFileName into the API call.
       *
       * const language = selectSkillLanguage(getState()) || 'en';
       * const templateFileName =  `${templateId}-actions-${language}.json`;
       */

      const response = await API.getTemplate(`${templateId}-actions-en.json`);
      return response;
    } catch (err) {
      dispatch(addErrorMessage(err));
      throw err;
    }
  }
);

export const getTemplateMetadata = createAsyncThunk<
  AllTemplateMetadata,
  void,
  CreateAsyncThunk
>('templates/metadata/list', async (_, { dispatch }) => {
  try {
    /**
     * NOTE: In the future, when we have template metadata JSON's in other
     * languages (e.g. French, Spanish), we'll want to pull the skill language
     * to build the metadataFileName and pass metadataFileName into the API call.
     *
     * const language = selectSkillLanguage(getState()) || 'en';
     * const metadataFileName = `metadata-${language}.json`;
     */
    return await API.getTemplateMetadata('metadata-v2-en.json');
  } catch (err) {
    dispatch(addErrorMessage(err));
    throw err;
  }
});
